import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-acao-item',
  templateUrl: './acao-item.component.html',
  styleUrls: ['./acao-item.component.scss']
})
export class AcaoItemComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
